<template>
  <div
    class="border-box"
    :style="{width:`${width+4}px`}"
  >
    <div
      class="border"
      :style="{width:width+'px',height:height+'px'}"
    >
      <img
        class="corner corner-top corner-left"
        src="@/assets/images/corner.png"
        alt=""
      >
      <img
        class="corner corner-top corner-right"
        src="@/assets/images/corner.png"
        alt=""
      >
      <img
        class="corner corner-bottom corner-left"
        src="@/assets/images/corner.png"
        alt=""
      >
      <img
        class="corner corner-bottom corner-right"
        src="@/assets/images/corner.png"
        alt=""
      >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props:{
    width:{
      type:[String,Number],
      default:420,
    },
     height:{
      type:[String,Number],
      default:556,
    }
  }
}
</script>
<style lang="scss">
  .border-box{
    position:relative;
     .border{    
      border:2px solid #373774;
      border-radius: 8px;
      background-color:#1c2046;
      overflow:hidden;
    .corner{
      position: absolute;
      z-index:1;
      &.corner-left{
        left:0;
      }
      &.corner-right{
        right:0;       
      }
    }
    .corner-top{
      top:0;
      &.corner-right{
        transform: rotate(90deg);
      }    
    }
    .corner-bottom{
      bottom:0;
      &.corner-right{
        transform: rotate(180deg);
      }
      &.corner-left{
        transform:rotate(-90deg);
      }
    }  
   }
  }
  
</style>